import React from 'react';
import SidebarNavItem from './SidebarNavItem';

/**
 * @param {Object} props
 * @param {import('../../navigation/buildNavSections').ResolvedNavSection} props.section
 * @param {string} props.pathname
 * @param {boolean} props.collapsed
 * @param {(item: import('../../navigation/buildNavSections').ResolvedNavItem) => void} props.onSelect
 * @param {(pathname: string, item: import('../../navigation/buildNavSections').ResolvedNavItem) => boolean} props.isActive
 */
export default function SidebarNavSection({
  section,
  pathname,
  collapsed,
  onSelect,
  isActive,
  pendingActionId = null,
}) {
  return (
    <div data-walkthrough={`nav-section-${section.id}`}>
      {!collapsed ? (
        <p className="filter-label px-2.5 pb-0.5 pt-1.5 text-gray-500 dark:text-gray-400 max-md:px-2 max-md:pt-1 max-md:pb-0">
          {section.title}
        </p>
      ) : (
        <div className="my-2 border-t border-gray-200 dark:border-gray-700" aria-hidden="true" />
      )}
      <ul className="space-y-0.5" role="list">
        {section.items.map((item) => (
          <li key={item.id}>
            <SidebarNavItem
              item={item}
              isActive={isActive(pathname, item)}
              collapsed={collapsed}
              onSelect={onSelect}
              pending={pendingActionId != null && item.actionId === pendingActionId}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
